// extracted by mini-css-extract-plugin
module.exports = {"buttonsBlock":"LogoffModal_buttonsBlock__2RXtE","logoffText":"LogoffModal_logoffText__1l7wB"};